import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer21 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Lehengas', path: '/template21/collections/lehengas' },
        { label: 'Sarees', path: '/template21/collections/sarees' },
        { label: 'Sherwanis', path: '/template21/collections/sherwanis' },
        { label: 'Indo-Western', path: '/template21/collections/indo-western' },
        { label: 'Evening Wear', path: '/template21/collections/evening-wear' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template21/contact' },
        { label: 'Shipping Policy', path: '/template21/shipping-policy' },
        { label: 'Returns & Exchange', path: '/template21/shipping-exchange' },
        { label: 'FAQs', path: '/template21/faqs' },
        { label: 'Track Order', path: '/template21/orders' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>

            <footer style={{ backgroundColor: '#0A0A0A', borderTop: '1px solid #2A2A2A' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                    className="noir-footer-main"
                >
                    <div className="noir-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: '#C9A96E',
                                    letterSpacing: '4px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                NOIR
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#8A8A7A',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Where Darkness Meets Elegance
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid #2A2A2A',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#C9A96E',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#C9A96E';
                                        e.currentTarget.style.backgroundColor = 'rgba(201,169,110,0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#2A2A2A';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <Instagram size={18} />
                                </a>
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid #2A2A2A',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#C9A96E',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#C9A96E';
                                        e.currentTarget.style.backgroundColor = 'rgba(201,169,110,0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#2A2A2A';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <Facebook size={18} />
                                </a>
                                <a
                                    href="#"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: '1px solid #2A2A2A',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#C9A96E',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#C9A96E';
                                        e.currentTarget.style.backgroundColor = 'rgba(201,169,110,0.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#2A2A2A';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    {/* Pinterest SVG icon */}
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M8 12a4 4 0 1 1 8 0c0 2.5-1.5 4.5-3 6l-1 3" />
                                        <path d="M12 2a10 10 0 1 0 4 19.2" />
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#C9A96E',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {collectionsLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#F5F0EB',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C9A96E')}
                                            onMouseLeave={(e) => (e.target.style.color = '#F5F0EB')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#C9A96E',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '12px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#F5F0EB',
                                                cursor: 'pointer',
                                                transition: 'color 0.3s ease',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#C9A96E')}
                                            onMouseLeave={(e) => (e.target.style.color = '#F5F0EB')}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Get In Touch */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#C9A96E',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 24px 0',
                                }}
                            >
                                Get In Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#C9A96E', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#F5F0EB',
                                        }}
                                    >
                                        hello@noir.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#C9A96E', flexShrink: 0 }} />
                                    <span
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#F5F0EB',
                                        }}
                                    >
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    {/* WhatsApp SVG icon */}
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#C9A96E"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ flexShrink: 0 }}
                                    >
                                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                    </svg>
                                    <span
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#F5F0EB',
                                        }}
                                    >
                                        Chat with us
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#C9A96E', flexShrink: 0, marginTop: '2px' }} />
                                    <span
                                        style={{
                                            fontFamily: "'DM Sans', -apple-system, sans-serif",
                                            fontSize: '14px',
                                            color: '#F5F0EB',
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        Mumbai, Maharashtra, India
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Newsletter Section */}
                <div style={{ backgroundColor: '#141414', borderTop: '1px solid #2A2A2A', borderBottom: '1px solid #2A2A2A' }}>
                    <div
                        style={{
                            maxWidth: '700px',
                            margin: '0 auto',
                            padding: '48px 24px',
                            textAlign: 'center',
                        }}
                    >
                        <h4
                            style={{
                                fontFamily: "'Cormorant Garamond', Georgia, serif",
                                fontSize: '24px',
                                fontWeight: 500,
                                color: '#F5F0EB',
                                letterSpacing: '2px',
                                margin: '0 0 8px 0',
                            }}
                        >
                            Stay in the world of NOIR
                        </h4>
                        <p
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '14px',
                                color: '#8A8A7A',
                                margin: '0 0 24px 0',
                            }}
                        >
                            Subscribe for exclusive collections, private events, and behind-the-scenes access.
                        </p>
                        <form
                            onSubmit={handleSubscribe}
                            style={{
                                display: 'flex',
                                gap: '0',
                                maxWidth: '500px',
                                margin: '0 auto',
                            }}
                            className="noir-newsletter-form"
                        >
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                style={{
                                    flex: 1,
                                    padding: '14px 20px',
                                    backgroundColor: '#0A0A0A',
                                    border: '1px solid #2A2A2A',
                                    borderRight: 'none',
                                    color: '#F5F0EB',
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    outline: 'none',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    padding: '14px 32px',
                                    backgroundColor: '#C9A96E',
                                    color: '#0A0A0A',
                                    border: 'none',
                                    fontFamily: "'DM Sans', -apple-system, sans-serif",
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => (e.target.style.backgroundColor = '#D4B87A')}
                                onMouseLeave={(e) => (e.target.style.backgroundColor = '#C9A96E')}
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '24px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '16px',
                        }}
                        className="noir-footer-bottom"
                    >
                        <p
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '12px',
                                color: '#8A8A7A',
                                margin: 0,
                            }}
                        >
                            &copy; 2026 NOIR. All rights reserved.
                        </p>
                        <p
                            style={{
                                fontFamily: "'DM Sans', -apple-system, sans-serif",
                                fontSize: '12px',
                                color: '#8A8A7A',
                                margin: 0,
                                fontStyle: 'italic',
                            }}
                        >
                            Crafted with love in India
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            {/* Visa */}
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#1A1A1A" stroke="#2A2A2A" />
                                <text x="18" y="14" textAnchor="middle" fill="#8A8A7A" fontSize="8" fontWeight="bold" fontFamily="DM Sans, sans-serif">VISA</text>
                            </svg>
                            {/* Mastercard */}
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#1A1A1A" stroke="#2A2A2A" />
                                <circle cx="15" cy="12" r="5" fill="#8A8A7A" opacity="0.5" />
                                <circle cx="21" cy="12" r="5" fill="#8A8A7A" opacity="0.5" />
                            </svg>
                            {/* UPI */}
                            <svg width="36" height="24" viewBox="0 0 36 24" fill="none">
                                <rect width="36" height="24" rx="2" fill="#1A1A1A" stroke="#2A2A2A" />
                                <text x="18" y="14" textAnchor="middle" fill="#8A8A7A" fontSize="7" fontWeight="bold" fontFamily="DM Sans, sans-serif">UPI</text>
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Responsive Styles */}
                <style>{`
                    .noir-footer-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 48px;
                    }
                    @media (max-width: 768px) {
                        .noir-footer-grid {
                            grid-template-columns: 1fr;
                            gap: 40px;
                        }
                        .noir-footer-main {
                            padding: 40px 24px !important;
                        }
                        .noir-footer-bottom {
                            flex-direction: column;
                            align-items: center !important;
                            text-align: center;
                        }
                        .noir-newsletter-form {
                            flex-direction: column !important;
                        }
                        .noir-newsletter-form input {
                            border-right: 1px solid #2A2A2A !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .noir-footer-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                `}</style>
            </footer>
        </>
    );
};

export default Footer21;
